import axios from 'axios'

const actions = {    
	setRemember(context, payload){       
		context.commit('setRemember', payload)        
	},
	setRlEntryAddDialogView2(context, payload){
		context.commit('setRlEntryAddDialogView2', payload)
	},
	setErrorMessage(context, payload){    
		context.commit('setErrorMessage', payload)
	},
	setRlEditNote(context, payload){      
		context.commit('setRlEditNote', payload)
	},
	setRlEntry(context, payload) {
		context.commit('setRlEntry', payload)
	},
	setRlEntryTableOptions(context, payload) {
		context.commit('setRlEntryTableOptions', payload)
	},
	setRlAddDialog(context, payload) {
		context.commit('setRlAddDialog', payload)
	},
	setRlAddDialogList(context, payload) {
		context.commit('setRlAddDialogList', payload)
	},
	clearRlAddDialogList(context, payload) {
		context.commit('clearRlAddDialogList', payload)
	},
	deleteRlAddDialogList(context, payload) {
		context.commit('deleteRlAddDialogList', payload)
	},
	setRlEditDialog(context, payload) {    
		context.commit('setRlEditDialog', payload)
	},
	setRlDeleteDialog(context, payload) {
		context.commit('setRlDeleteDialog', payload)
	},
	setRlImageAddDialog(context, payload) {
		context.commit('setRlImageAddDialog', payload)
	},
	setRlImageEditDialog(context, payload) {
		context.commit('setRlImageEditDialog', payload)
	},
	setRlImageCloseDialog(context, payload) {
		context.commit('setRlImageCloseDialog', payload)
	},
	setRlImageSaveDialog(context, payload) {
		context.commit('setRlImageSaveDialog', payload)
	},
	setRlImageFullSizeDialog(context, payload){
		context.commit('setRlImageFullSizeDialog', payload)
	},
	setUser(context, payload) {
		context.commit('setUser', payload)
	},
	deleteUser(context) {
		context.commit('deleteUser')
	},
	setLoginAlert(context, payload) {
		context.commit('setLoginAlert', payload)
	},
	setShowVerificationMessage(context, payload) {
		context.commit('setShowVerificationMessage', payload)
	},
  async setRlEntryList(context) {

    context.commit('setRlEntryTable', {loading: true})

    try {
      const { page, sortBy, sortDesc, filters } = context.getters.getRlEntryTableOptions
      let url = 'api/v1/recyclingLedgerEntries?'

      for (const prop in filters) {
        if(filters[prop]) {
          url += 'filter%5B'+prop+'%5D='+filters[prop]+'&'
        }         
      }

      if (sortBy.length === 1 && sortDesc.length === 1) {
        if (sortDesc[0]) {
        	url += 'page=' + page + '&sortBy=' + sortBy[0] + '&sortOrder=desc'
        	const response = await axios.get(url)
        	context.commit('setRlEntryList', {data: response.data.data, total: response.data.meta.total})
        } else {
        	url += 'page=' + page + '&sortBy=' + sortBy[0] + '&sortOrder=asc'
          const response = await axios.get(url)
          context.commit('setRlEntryList', {data: response.data.data, total: response.data.meta.total})
        }
      }
  	} catch (error) {
    	context.commit('setRlEntryTable', {loading: false})
    	context.commit('setErrorMessage', error.message)   
  	}
    context.commit('setRlEntryTable', {loading: false})
	},
  async setLicenseList(context) {
    try {
			const response = await axios.get('api/v1/licenses')          
			context.commit('setLicenseList', response.data.data) 
    } catch (error) {
      context.commit('setErrorMessage', error.message)   
    }
  },
  async setRoleList(context) {
    try {
			const response = await axios.get('api/v1/roles')
			context.commit('setRoleList', response.data.data)
		} catch (error) {
			context.commit('setErrorMessage', error.message)   
		}
  },
  async setPermissionList(context) {
  	try {
      const response = await axios.get('api/v1/permissions')
      context.commit('setPermissionList', response.data.data)
    } catch (error) {
      context.commit('setErrorMessage', error.message)   
  	}
  },
	async setEntryTypeList(context) {
		try {
			const response = await axios.get('api/v1/entryTypes')
			context.commit('setEntryTypeList', response.data.data)
		} catch (error) {
			context.commit('setErrorMessage', error.message)   
		}
	},
	async setMaterialList(context) {
		try {
			const response = await axios.get('api/v1/materials')
			context.commit('setMaterialList', response.data.data)
		} catch (error) {
			context.commit('setErrorMessage', error.message)   
		}
	},
	async setGradeList(context) {
		try {
			const response = await axios.get('api/v1/grades')
			context.commit('setGradeList', response.data.data)
		} catch (error) {
			context.commit('setErrorMessage', error.message)   
		}
	},
	async setIncotermList(context) {
		try {
			const response = await axios.get('api/v1/incoterms')
			context.commit('setIncotermList', response.data.data)
		} catch (error) {
			context.commit('setErrorMessage', error.message)   
		}
	},
	async setCurrencyList(context) {
		try {
			const response = await axios.get('api/v1/currencies')
			context.commit('setCurrencyList', response.data.data)
		} catch (error) {
			context.commit('setErrorMessage', error.message)   
		}
	},
	async setHs2List(context) {
		try {
			const response = await axios.get('api/v1/recyclingLedgerEntries/hs2s')
			context.commit('setHs2List', response.data.data)
		} catch (error) {
			context.commit('setErrorMessage', error.message)   
		}
	},
	async setDomesticCompanyList(context) {
		try {
			const response = await axios.get('api/v1/recyclingLedgerEntries/domesticHaulageCompanies')
			context.commit('setDomesticCompanyList', response.data.data)
		} catch (error) {       
			context.commit('setErrorMessage', error.message)   
		}
	},
	async setShippingCompanyList(context) {
		try {
			const response = await axios.get('api/v1/recyclingLedgerEntries/internationalShippingCompanies')
			context.commit('setShippingCompanyList', response.data.data)
		} catch (error) {
			context.commit('setErrorMessage', error.message)   
		}
	},
	async setInspectionCompanyList(context) {
		try {
			const response = await axios.get('api/v1/recyclingLedgerEntries/inspectionCompanies')
			context.commit('setInspectionCompanyList', response.data.data)
		} catch (error) {
			context.commit('setErrorMessage', error.message)   
		}
	},
	async setCountryList(context) {
		try {
			const response = await axios.get('api/v1/countries')
			context.commit('setCountryList', response.data.data)
		} catch (error) {
			context.commit('setErrorMessage', error.message)   
		}
	},
	async setUnitOfMeasureList(context) {
		try {
			const response = await axios.get('api/v1/unitsOfMeasure')
			context.commit('setUnitOfMeasureList', response.data.data)
		} catch (error) {
			context.commit('setErrorMessage', error.message)   
		}
	},
	async setRecyclingLedgerEntryList(context) {
		try {
			const response = await axios.get('api/v1/recyclingLedgerEntries')
			context.commit('setRecyclingLedgerEntryList', response.data.data)
		} catch (error) {
			context.commit('setErrorMessage', error.message)   
		}
	},
	setRecyclingLedgerEntry(context, payload) {
		context.commit('setRecyclingLedgerEntry', payload)
	},
	deleteRecyclingLedgerEntry(context, payload) {
		context.commit('deleteRecyclingLedgerEntry', payload)
	},
	async setCompanyList(context) {
		try {
			const response = await axios.get('api/v1/recyclingLedgerEntries/companies')        
			context.commit('setCompanyList', response.data.data)
		} catch (error) {               
			context.commit('setErrorMessage', error.message)         
		}
	},
	async setPBIReportList(context) {
		try {
			const response = await axios.get('api/v1/pbiReports')
			context.commit('setPBIReportList', response.data.data)
		} catch (error) {
			context.commit('setErrorMessage', error.message)   
		}
	},
	async setPBIToken(context, payload) {
		try {
			let pbiList = JSON.parse(JSON.stringify(context.getters.getPBITokenList))
			
			let pbiReport = pbiList.find(x => x.report_id === payload)           
			
			if(!pbiReport) {            
				const response1 = await axios.get('api/v1/pbiTokens/' + payload)                   
				context.commit('setPBIToken', response1.data.data)             
			} else if (pbiReport && new Date(pbiReport.pbi_expiration_datetime + 'Z').toISOString() < new Date().toISOString()) {                                   
				context.commit('deletePBIToken', pbiReport.report_id)
				const response2 = await axios.get('api/v1/pbiTokens/' + payload)           
				context.commit('setPBIToken', response2.data.data)
			}
		} catch (error) {
			// context.commit('setErrorMessage', error.message)   
		}
	}
}

export default actions;
